(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('commissione-ruolo', {
            parent: 'entity',
            url: '/commissione-ruolo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.commissioneRuolo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolos.html',
                    controller: 'CommissioneRuoloController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commissioneRuolo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('commissione-ruolo-detail', {
            parent: 'commissione-ruolo',
            url: '/commissione-ruolo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.commissioneRuolo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-detail.html',
                    controller: 'CommissioneRuoloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('commissioneRuolo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CommissioneRuolo', function($stateParams, CommissioneRuolo) {
                    return CommissioneRuolo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'commissione-ruolo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('commissione-ruolo-detail.edit', {
            parent: 'commissione-ruolo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-dialog.html',
                    controller: 'CommissioneRuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommissioneRuolo', function(CommissioneRuolo) {
                            return CommissioneRuolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('commissione-ruolo.new', {
            parent: 'commissione-ruolo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-dialog.html',
                    controller: 'CommissioneRuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('commissione-ruolo', null, { reload: 'commissione-ruolo' });
                }, function() {
                    $state.go('commissione-ruolo');
                });
            }]
        })
        .state('commissione-ruolo.edit', {
            parent: 'commissione-ruolo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-dialog.html',
                    controller: 'CommissioneRuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CommissioneRuolo', function(CommissioneRuolo) {
                            return CommissioneRuolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('commissione-ruolo', null, { reload: 'commissione-ruolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('commissione-ruolo.delete', {
            parent: 'commissione-ruolo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/commissione-ruolo/commissione-ruolo-delete-dialog.html',
                    controller: 'CommissioneRuoloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CommissioneRuolo', function(CommissioneRuolo) {
                            return CommissioneRuolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('commissione-ruolo', null, { reload: 'commissione-ruolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
